import { SocialPage } from "@missionlabs/smartagent-service-social/dist/types/social-page";

export enum ChannelSettingsSocialTypes {
  SET_SOCIAL_PAGE_CONFIGS = "channelSettings/SET_SOCIAL_PAGE_CONFIGS",
  SOCIAL_PAGE_CONFIGS_LOADING = "channelSettings/SOCIAL_PAGE_CONFIGS_LOADING",
  SET_SELECTED_SOCIAL_PAGE_CONFIG = "channelSettings/SET_SELECTED_SOCIAL_PAGE_CONFIG",
  SET_SOCIAL_LOGIN_DETAILS = "channelSettings/SET_SOCIAL_LOGIN_DETAILS",
  SOCIAL_LOGIN_DETAILS_LOADING = "channelSettings/SOCIAL_LOGIN_DETAILS_LOADING",
}

export enum Subchannel {
    POST = 0,
    DM = 1,
}

export interface PageConnectionStatus extends Pick<SocialPage, "isConnected" | "connectionCheckedTimestamp"> {}

export interface SocialLoginDetails {
  twitter?: TwitterLoginDetails;
  facebook?: FacebookLoginDetails;
  instagram?: FacebookLoginDetails;
}

export interface FacebookLoginDetails {
  shortUserToken?: string;
  availablePages?: FacebookPageFromGraphAPI[];
}

export interface TwitterLoginDetails {
  url?: string;
  requestToken?: string;
  requestTokenSecret?: string;
  connectButtonClicked?: boolean;
}

interface CommonOnboardRequest {
  enableDMs: boolean;
  commentQueue: string;
  dmQueue: string;
  facia: string;
}

export interface TwitterOnboardRequest extends CommonOnboardRequest {
  requestToken: string;
  requestTokenSecret: string;
  pin: string;
  enableTweets: boolean;
}

export interface FacebookOnboardRequest extends CommonOnboardRequest {
  appID: string;                      
  pageID: string;
  pageName: string;
  shortUserToken: string;
  enableComments: boolean;
}

export interface InstagramOnboardRequest extends FacebookOnboardRequest {
  facebookPageID: string;
}

export interface FacebookPageFromGraphAPI {
  id: string;
  name: string;
  connected_instagram_account?: {
    id: string;
    name: string;
  };
}

export interface WhatsAppReadReceiptRequest {
  messageID: string;
  whatsAppCustomerConfigID: string;
  phoneNumberID: string;
}
